export default __webpack_public_path__ + "static/media/YesVote.f2296a98.svg";